import { useEffect, useState } from "react";
import "./styles/App.scss";

function Disclaimer({
  callback,
}: {
  callback: ((val: boolean) => void) | null;
}) {
  const [accepted, setAccepted] = useState(() => {
    return callback
      ? false
      : localStorage.getItem("accepted-disclaimer") === "yes";
  });

  useEffect(() => {
    if (accepted && !callback) {
      localStorage.setItem("accepted-disclaimer", "yes");
    }
    if (callback) callback(!accepted);
  }, [accepted]);

  return (
    <div>
      {!accepted || callback != null ? (
        <div className="disclaimer-screen">
          <div className="disclaimer">
            <div className="disclaimer-title">Disclaimer</div>
            <span style={{ textAlign: "center" }}>
              Please be advised that RateYourLandlord does not warrant the
              accuracy of any data presented here.{" "}
            </span>
            <br />
            <span>
              As the data provided has been submitted by community members, and
              from public sources like the Oregon Secretary of State, it has not
              been expressly verified and you agree to use it at your own risk.
              RateYourLandlord shares the information in this system “as is” and
              makes no guarantees, representations or warranties of any kind,
              express or implied, arising by law or otherwise, including but not
              limited to, content, accuracy, completeness, timeliness,
              reliability, fitness for a particular purpose, usefulness, use or
              results to be obtained from this data, or that the data will be
              error-free. By using this tool, you agree that any use of, and
              reliance upon, the data will be at your sole discretion and risk,
              and you agree to take full responsibility therefor and shall not
              hold RateYourLandlord liable for losses caused by using this
              information.
            </span>
            {/* <span>The information shown here is not verfied to be 100% correct.</span>
                    <span>Data is collected from PortlandMaps.com, the Oregon Secretary of State and Multonomah County Court Records</span> */}
            <button className="got-it" onClick={() => setAccepted(true)}>
              understood
            </button>
            {/* <button className="got-it" onClick={() => setAccepted(true)}>I agree to the above terms and conditions</button> */}
          </div>
        </div>
      ) : undefined}
    </div>
  );
}

export default Disclaimer;
